import { Plugin } from '@nuxt/types';
import { AdFormOptions } from '@ads/types/AdForm';

import getAdBlockLayerState from '@root/modules/ads/utils/getAdBlockLayerState';
// eslint-disable-next-line import/named
import { detectAnyAdblocker } from 'vue-adblock-detector';

const portalAds: Plugin = async (ctx) => {
  const { store, app } = ctx;
  // Access channel settings
  const { application } = app.$channelConfig('settings');
  // Access default banner placements
  const placements: Record<string, AdFormOptions> | null = { ...app.$channelConfig('ads').component.adForm.placements };

  // Access paywall settings
  const { hasChannelAccess, adFree } = app.$instanceConnector('paywall').state;

  // detect native app
  const isApp = application.type?.includes('NativeApp');

  const defaultAdsSettings = ({ isAdFree, isCustomer, isLoggedIn }: { isAdFree: boolean; isCustomer: boolean; isLoggedIn: boolean }) => {
    const mkw = ['channel_vue', `logged-${isLoggedIn ? 'in' : 'out'}`];

    if (isCustomer) {
      mkw.push('subscriber');
    }

    return {
      mkw,
      mkv: [],
      placements,
      disableAds: [],
      isAdFree,
      isApp,
      isLoggedIn,
      isCustomer,
    };
  };

  // Detect adblock and commit state independantly of customer/paywall state
  const adBlockEnabled = await detectAnyAdblocker();
  const enableAdBlockLayer = getAdBlockLayerState({ application, adBlockEnabled, hasChannelAccess, adFree });
  store.commit('adForm/setAdBlockLayerState', enableAdBlockLayer);

  const { isInited, isLoggedIn } = ctx.app.$instanceConnector('customer').state;

  if (isInited && !isLoggedIn) {
    store.commit('adForm/setAdsRenderingState', true);
    store.commit('adForm/setDefaultAdsSettings', defaultAdsSettings({ isAdFree: adFree, isCustomer: hasChannelAccess, isLoggedIn }));
  } else {
    store.commit('adForm/setAdsRenderingState', false);
  }

  // Update ads settings when customer logs in and has access to channel or has adFree package
  app.$eventHandler.on('paywall-state', () => {
    // Access paywall settings
    const { hasChannelAccess, adFree } = app.$instanceConnector('paywall').state;

    store.commit('adForm/setAdsRenderingState', true);
    store.commit('adForm/setDisabledAdsCondition', { type: 'subscriber', disable: hasChannelAccess });
    store.commit('adForm/setDisabledAdsCondition', { type: 'adFree', disable: adFree });

    const isLoggedIn = ctx.app.$instanceConnector('customer').state.isLoggedIn;
    store.commit('adForm/setDefaultAdsSettings', defaultAdsSettings({ isAdFree: adFree, isCustomer: hasChannelAccess, isLoggedIn }));
  });
};

export default portalAds;
